<template>
  <div @click="isPopinActive = true">
    <slot />

    <PopinBase :is-active="isPopinActive" size="2xs" @close="isPopinActive = false" :z="500">
      <template #body>
        <div class="p-3 grow space-y-6 overflow-auto bg-white dark:bg-dark-920 dark:text-dark-50 text-light-950">
          <div class="space-y-0.5" v-if="displayedOptions.filter(o => o.isPriority).length > 0">
            <div
              class="flex items-center p-3 rounded-md text-base font-medium leading-snug cursor-pointer  bg-charcoal-100 dark:bg-dark-800"
              :class="[
                localValue.length >= 5 ? 'opacity-50' : '',
                localValue.length >= 5 && !localValue.includes(option.value) ? 'pointer-events-none' : '',
                localValue === option.value || (Array.isArray(localValue) && localValue.includes(option.value)) ? 'bg-charcoal-100' : ''
              ]"
              v-for="option in displayedOptions.filter(o => o.isPriority)" @click="() => onToggle(option.value)"
              :key="option.value"
            >
              <IconBase :name="option.icon" :width="24" class="shrink-0 mr-2" v-if="option.icon" />

              <p class="grow">{{ option.label }}</p>

              <IconBase name="check" :width="16" class="ml-2.5" v-if="localValue.includes(option.value)" />
            </div>
          </div>
          
          <div class="space-y-0.5">
            <div
              class="flex items-center p-3 rounded-md text-base font-medium leading-snug cursor-pointer bg-charcoal-100 dark:bg-dark-800"
              :class="[
                localValue.length >= 5 ? 'opacity-50' : '',
                localValue.length >= 5 && !localValue.includes(option.value) ? 'pointer-events-none' : '',
                localValue === option.value || (Array.isArray(localValue) && localValue.includes(option.value)) ? 'bg-charcoal-100' : ''
              ]"
              v-for="option in displayedOptions" @click="() => onToggle(option.value)"
              :key="option.value"
            >
              <IconBase :name="option.icon" :width="24" class="shrink-0 mr-2" v-if="option.icon" />

              <p class="grow">{{ option.label }}</p>

              <IconBase name="check" :width="16" class="ml-2.5" v-if="localValue.includes(option.value)" />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="border-t border-charcoal-100 shadow-bar-xs dark:border-dark-600">
          <div class="p-4 text-right border-t border-charcoal-100" v-if="Array.isArray(modelValue)">
            <ButtonBase color="white" @click="onSubmit">
              {{ $t('actions.save') }}
            </ButtonBase>
          </div>
          <div class="p-2" v-else>
            <InputBase v-model="search" color="transparent" class="!border-none" :label="$t('actions.search') + '...'" />
          </div>
        </div>
      </template>
    </PopinBase>
  </div>
</template>


<script lang="ts" setup>
const props = withDefaults(defineProps<{
  modelValue: string | string[]
  options: {
    label: string
    icon?: string
    isPriority?: boolean
    value: string
  }[]
}>(), {

})

const { modelValue } = toRefs(props)

const localValue: Ref<string | string[]> = ref(Array.isArray(props.modelValue) ? '' : [])

watch(modelValue, (v) => localValue.value = v, { immediate: true })

const isPopinActive = ref(false)

const onToggle = (value: string) => {
  if (Array.isArray(localValue.value)) {
    if (localValue.value.includes(value)) {
      localValue.value = localValue.value.filter(f => f !== value)
    } else {
      localValue.value = [ ...localValue.value, value ]
    }
  } else {
    localValue.value = value
    onSubmit()
  }
}

const onSubmit = () => {
  emit('update:modelValue', localValue.value)
  isPopinActive.value = false
}

const search = ref('')

const displayedOptions = computed(() => {
  return search.value.length >= 2 ? props.options.filter(o => normalize(o.label).includes(normalize(search.value))) : props.options
})

// META

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | string[]): void
}>()
</script>